import {
    Component,
    OnInit,
    ViewChild,
    EventEmitter,
    Output,
    Input
} from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { HelperService } from "../../services/helper.service";
import { MapDesignationService } from "../../services/mapdesignation.service";
import { ActivatedRoute } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { DesignationMasterService } from "../../services/designation-master.service";
import { ObjectivesService } from "../../services/objectives.service";

@Component({
    selector: "app-objectives-edit-modal-generate",
    templateUrl: "./objectives-edit-modal-generate.html",
    providers: [ObjectivesService],
})



export class AddGenerateModalComponent implements OnInit {

    @Input() header_id: number;
    @Output() dataToEmit: EventEmitter<any> = new EventEmitter<any>();
    @Output() tableReload: EventEmitter<any> = new EventEmitter();
    @ViewChild("swalModal") swalModal: any;
    @ViewChild("errorMessageHtml") errorMessageHtml: any;
    public successMsg: string = "";
    public htmlErrorMessage: string = "";
    Ratings: any = [];
    companySystemID = +this.helperService.getSelectedCompanyId();
    companyId = +this.helperService.getSelectedCompanyId();


    gapStatus = [
      { value: 0, label: "No" },
      { value: 1, label: "Yes" },
    ];

    ratingsList: any;

    constructor(
        public bsModalRef: BsModalRef,
        private helperService: HelperService,
        private modalService: BsModalService,
        private route: ActivatedRoute,
        private spinner: NgxSpinnerService,
        private objectivesService: ObjectivesService,
        private designationMasterService: DesignationMasterService,
    ) { }


    showErrorHtml() {
        setTimeout(() => {
          this.errorMessageHtml.show();
        }, 0);
      }
    
      closeModal() {
        this.bsModalRef.hide();
        this.modalService.setDismissReason("");
      }
    
      closeModalAfterCreate() {
        this.bsModalRef.hide();
        this.modalService.setDismissReason("");
      }
    
      showSuccessHtml() {
        setTimeout(() => {
          this.swalModal.show();
        }, 0);
      }



    ngOnInit() {
        this.header_id = Number(localStorage.getItem("objective-sedit_auto_id"));
        localStorage.removeItem("objective-sedit_auto_id");
        //console.log(this.header_id);
        this.retrieveObjRatings();
        this.getFormData();
    }


    public getFormData() {
      //console.log(this.companyId);
      const that = this;
      this.designationMasterService
        .getAllEmployeesFormData()
        .get({
          companyId: +that.helperService.getSelectedCompanyId(),
          // type: "create",
        })
        .subscribe(
          (data) => {
            const resp = data.data.data;
            //console.log(resp);
            that.ratingsList = that.helperService.setSelect2DropDownOptions(
              resp.ratingCategories,
              "auto_id",
              "description"
            );
            //console.log(resp.ratingCategories);
          },
          (error) => {}
        );
    }


    addGenerate(formData: any) {
      const isGapAnalysis = formData.is_gap_analysis || 0;
        const requestData = {
            order: formData.order,
            header_des: formData.header_des,
            points: formData.points,
            is_gap_analysis: isGapAnalysis,
            company_id: this.companySystemID,
            master_id: this.header_id,
        };
        //console.log(requestData);
        let that = this;
        that.objectivesService.addGenerate()
          .post(requestData)
          .subscribe(
            (resp: any) => {
              //console.log(resp);
              that.successMsg = "Successfully added a new generate rating.";
              that.showSuccessHtml();
              that.closeModalAfterCreate();
              this.tableReload.emit();
            },
            (error) => {
              that.htmlErrorMessage = "";
              if (error.status == 500) {
                that.htmlErrorMessage = error.data.message;
                that.showErrorHtml();
              } else if (error.status == 422) {
                that.htmlErrorMessage = that.helperService.serverSideError422(error.data.message);
                that.showErrorHtml();
              }
            }
          );
    }


    retrieveObjRatings(): void {
      this.Ratings = [];
      let dataTablesParameters: any = {
        companyId: this.helperService.getSelectedCompanyId(),
      };
      this.objectivesService
        .retrieveObjRatings()
        .customPOST(dataTablesParameters)
        .subscribe(
          (resp: any) => {
            let data = JSON.parse(resp._body);
            this.Ratings = data.data;
            // //console.log(this.Ratings);
          },
          (err: any) => {
            // //console.log(err);
          }
        );
    }



}



// WEBPACK FOOTER //
// /app/src/app/competancy/objectives-edit-modal-generate/objectives-edit-modal-generate.ts